/**
 * App banner component
 */

// React
import React, { FC, useEffect, useState } from 'react';

// Library
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Material
import { styled } from '@mui/material/styles';
import { Box, useMediaQuery, useTheme } from '@mui/material';

// Recoil
import { loadingAtom } from 'recoil/LoadingRecoil';
import { useSetRecoilState } from 'recoil';

// Utils
import { AWS_S3 } from 'utils/constants';

// Services
import BannerService from 'services/AuthService';

// Settings react-slick
const settings = {
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  waitForAnimate: false,
  arrows: false,
};

// Styled
const BannerContainer = styled('img')(({ theme }) => ({
  height: 'auto',
  width: '100%',
  borderRadius: '10px',
  marginBottom: '10px',
  [theme.breakpoints.down('sm')]: {
    height: '280px',
  },
}));

// Component
const Banner: FC = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const setIsLoading = useSetRecoilState(loadingAtom);
  const [banners, setBanners] = useState([]);
  const queryParams = new URLSearchParams(location.search);
  const authenCode = queryParams.get('code');

  const getBanners = async () => {
    try {
      setIsLoading(true);
      const res = await BannerService.getBanners();
      const bannersForPC = res?.pc || [];
      const bannersForSP = res?.sp || [];
      const banners = bannersForPC.map((pcBanner: any) => {
        const spBanner = bannersForSP.find(
          (spBanner: any) => spBanner?.position === pcBanner?.position
        );
        return {
          desktop: pcBanner,
          mobile: spBanner,
        };
      });

      setBanners(banners);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!authenCode) {
      getBanners();
    }
  }, []);

  return (
    <Slider {...settings}>
      {banners?.map((banner: any, index) => (
        <Box key={index}>
          <BannerContainer
            src={`${AWS_S3.BASE_URL}/${isSmallScreen ? banner?.mobile?.name : banner?.desktop?.name}`}
            key={index}
          />
        </Box>
      ))}
    </Slider>
  );
};

export default Banner;
